/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef, useCallback, useMemo } from "react";
import { salesService } from "../../services/sales.service";
import { Dropdown } from "react-bootstrap";
import LogicContext from "../../Context/LogicContext";
import { GetSalesOrderList, SetSalesOrderList } from "../../store/salesOrderAtom";
import CurrencyFormat from "react-currency-format";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useLocation, useNavigate } from "react-router-dom";
import ActionPaneComponent from "../../helpers/ActionPaneComponent";
import { IoMdRefresh } from "react-icons/io";
import { useForm } from "react-hook-form";
import moment from "moment";
import { FaPlus } from "react-icons/fa";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import SalesOrderFilter from "./SalesOrderFilter";
import StatusBadge from "../../generals/StatusBadge";

const SalesOrderPage = () => {
  const { pathname } = useLocation();
  const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const { showToast } = useContext(LogicContext); // Select only needed context value
  const setSalesOrderData = SetSalesOrderList();
  const salesOrderData = GetSalesOrderList();
  const myPromiseModal = createModal(GeneralModal);
  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const [summaryList, setSummaryList] = useState({});
  const mountRef = useRef(false);
  const [searchText, setSearchText] = useState("");
  

  // Memoized columns to prevent recreation
  const columns = useMemo(
    () => [
      {
        title: "Reference",
        key: "Sales_Order_Ref_No",
        dataIndex: "Sales_Order_Ref_No",
        className: "text-primary",
        sorter: (a, b) => (a?.Sales_Order_Ref_No ?? "") - (b?.Sales_Order_Ref_No ?? ""),
      },
      {
        title: "Order Date",
        dataIndex: "Sales_Order_Date_String",
        sorter: (a, b) => (a?.Sales_Order_Date_String ?? "").localeCompare(b?.Sales_Order_Date_String ?? ""),
      },
      {
        title: "Order Number",
        dataIndex: "Sales_Order_No",
        sorter: (a, b) => (a?.Sales_Order_No ?? "").localeCompare(b?.Sales_Order_No ?? ""),
      },
      {
        title: "Customer Name",
        dataIndex: "Customer_Full_Name",
        sorter: (a, b) => (a?.Customer_Full_Name ?? "").localeCompare(b?.Customer_Full_Name ?? ""),
      },
      {
        title: "Email",
        dataIndex: "Customer_Email_Address",
        sorter: (a, b) => (a?.Customer_Email_Address ?? "").localeCompare(b?.Customer_Email_Address ?? ""),
      },
      {
        title: "Mobile",
        dataIndex: "Customer_Mobile_No",
        sorter: (a, b) => (a?.Customer_Mobile_No ?? "").localeCompare(b?.Customer_Mobile_No ?? ""),
      },
      {
        title: "Invoice Amount",
        dataIndex: "Sales_Order_Amount",
        sorter: (a, b) => (a?.Sales_Order_Amount ?? 0) - (b?.Sales_Order_Amount ?? 0),
        render: (record) => <span>{formatCustomNumber(record)}</span>,
      },
      {
        title: "Status",
        dataIndex: "Sales_Order_Status_Name",
        sorter: (a, b) => (a?.Sales_Order_Status_Name ?? "").localeCompare(b?.Sales_Order_Status_Name ?? ""),
        render: (record, row) => (
          <StatusBadge statusId={row?.Sales_Order_Status_Id} statusName={record} />
        ),
      },
    ],
    []
  );

  // Set table data from global state
  useEffect(() => {
    mountRef.current = true;
    if (salesOrderData["Sales_Order_Info"]?.length > 0) {
      setTableData(salesOrderData["Sales_Order_Info"]);
    }
    return () => {
      mountRef.current = false;
    };
  }, [salesOrderData]);

  // Handle session-based reload
  useEffect(() => {
    if (sessionStorage.getItem("reloadPage") === "true") {
      sessionStorage.removeItem("reloadPage");
      getPurchaseOrderListApi();
    }
  }, []);

  // Update summary list
  useEffect(() => {
    if (salesOrderData?.Amount_Summary?.length) {
      setSummaryList(salesOrderData.Amount_Summary[0]);
    }
  }, [salesOrderData]);

  // Fetch sales order list with abortable request
  const getPurchaseOrderListApi = useCallback(async () => {
    const abortController = new AbortController();
    try {
      const response = await salesService.getSalesOrderList({ signal: abortController.signal });
      if (mountRef.current && response?.data !== undefined) {
        setSalesOrderData(response.data);
      }
    } catch (err) {
      if (!abortController.signal.aborted) console.error(err);
    }
    return () => abortController.abort();
  }, [setSalesOrderData]);

  // Unified filter function
  const applyFilter = useCallback(
    (filterValue) => {
      const fullList = salesOrderData["Sales_Order_Info"] || [];
      if (Number(filterValue) === 0) {
        setTableData(fullList);
      } else {
        const filtered = fullList.filter(
          (item) => item.Sales_Order_Status_Id === Number(filterValue)
        );
        setTableData(filtered);
      }
    },
    [salesOrderData]
  );

  const onFilterSelect = useCallback(
    (sel) => {
      applyFilter(sel.Filtering_Field_Value);
    },
    [applyFilter]
  );

  const onButtonFilter = useCallback(
    (option) => {
      applyFilter(option);
    },
    [applyFilter]
  );

  const selectedTableItems = useCallback((itemList) => {
    setItemSelected(itemList);
  }, []);

  const addNewInvoice = useCallback(() => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }, [currModuleId, currModuleName, currUserMenu, navigate]);

  const bulkActions = useCallback(
    async (action) => {
      const result = await myPromiseModal({
        title: "Confirm your action!",
        body: `Do you want to ${action.Action_Name}?`,
        showInput: false,
        placeHolder: "",
      });
      if (result.decision === true) {
        const temp = itemSelected
          .map((item) => `<a><refno>${item.Sales_Order_Ref_No}</refno></a>`)
          .join("");
        const xml_string_refno = `<root>${temp}</root>`;
        try {
          const res = await salesService.setSalesOrderBulkAction({
            xml_string_refno,
            option: action.Procedure_Option,
          });
          if (res?.data !== undefined) {
            const { message_text } = res.data[0];
            showToast(message_text, "success");
            getPurchaseOrderListApi();
          }
        } catch (err) {
          showToast("Error", "error");
        }
      }
    },
    [itemSelected, myPromiseModal, showToast, getPurchaseOrderListApi]
  );

  const searchByDate = useCallback(async () => {
    const formData = getValues();
    try {
      const response = await salesService.getSalesOrderListByDate(formData);
      if (response?.data?.length) {
        setTableData(response.data);
      } else {
        showToast("No result found", "");
        setTableData([]);
      }
    } catch (err) {
      showToast("Error", "error");
    }
  }, [getValues, showToast]);

  const handleRowClick = useCallback(
    (data) => {
      const id = data["Sales_Order_Ref_No"];
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
    },
    [currModuleId, currModuleName, currUserMenu, navigate]
  );

  // Memoized summary cards to avoid redundant renders
  const summaryCards = useMemo(
    () =>
      [2, 3, 4, 5, 6].map((statusId, index) => (
        <div
          key={statusId}
          className="bg-white border-[1px] border-gray-200 py-3 px-3 rounded-xl"
        >
          <div
            onClick={() => onButtonFilter(statusId)}
            className={`show-cursor text-center text-4xl font-bold ${
              index === 0
                ? "text-primary"
                : index === 1
                ? "text-dark"
                : index === 2
                ? "text-danger"
                : index === 3
                ? "text-success"
                : "text-warning"
            }`}
          >
            {salesOrderData?.["sales_order_cart_info"]?.[index]?.["Total_Order"] || 0}
          </div>
          <div className="mt-1 text-xs font-medium text-gray-500 text-center">Qty</div>
          <div className="mt-3 text-sm text-gray-700 text-center font-bold">
            {salesOrderData?.["sales_order_cart_info"]?.[index]?.["Sales_Order_Status_Name"] || ""}
          </div>
        </div>
      )),
    [salesOrderData, onButtonFilter]
  );


  const onClearInput = ()=> {
    setSearchText("");
    setTableData(salesOrderData["Sales_Order_Info"] || []);

   }



  const handleSearch = (text) => {
    setSearchText(text);
   
     if (text.trim() === "") {
      setTableData(salesOrderData["Sales_Order_Info"] || []);
       return;
     }
   
     const searchTerm = text.toLowerCase();
     const filtered = (salesOrderData["Sales_Order_Info"] || []).filter(credit =>
       Object.values(credit).some(value => 
         value?.toString().toLowerCase().includes(searchTerm)
       )
     );
     setTableData(filtered); 
   };

  return (
    <>
      <div className="grid grid-auto-fit-[180px] gap-3 w-full">{summaryCards}</div>

      <div className="mt-6 md:flex items-end justify-between space-y-3 md:space-y-0">
        <div className="flex items-center space-x-2">
          {itemSelected.length > 0 ? (
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">Bulk Actions</Dropdown.Toggle>
              <Dropdown.Menu>
                {salesOrderData["Bulk_Action"]?.map((action, i) => (
                  <Dropdown.Item key={i} onClick={() => bulkActions(action)}>
                    {action.Action_Name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <SalesOrderFilter list={salesOrderData["Filtering_Criteria"]} onFilterSelect={onFilterSelect} />
          )}
          <Tooltip title="Reload">
            <div
              onClick={getPurchaseOrderListApi}
              className="h-fit w-fit p-2 rounded-full cursor-pointer hover:bg-gray-200 active:bg-gray-300"
            >
              <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />
            </div>
          </Tooltip>
        </div>

        <div className="flex flex-row items-end space-x-2">
          <div>
            <span className="ml-1 text-sm">From Date:</span>
            <input
              defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
              {...register("from_date")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <span className="ml-1 text-sm">To Date:</span>
            <input
              {...register("to_date")}
              defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <button
              onClick={searchByDate}
              type="button"
              className="text-sm text-white px-3 bg-blue-500 rounded py-2.5"
            >
              Search
            </button>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <Tooltip title="Add New">
            <button
              onClick={addNewInvoice}
              className="ml-2 h-fit w-fit px-3 py-2.5 bg-gray-200 border-[1.5px] border-gray-300 rounded-md text-white focus:outline-none font-medium hover:bg-gray-100 active:bg-gray-200 transition-all duration-200"
            >
              <FaPlus className="h-[16px] w-[16px] text-gray-600" />
            </button>
          </Tooltip>
        </div>

      </div>

                  {/* Start of search */}
    <div className="flex justify-center mt-4">
    <div className="flex flex-col w-full md:w-1/3">
      <input
        type="text"
        placeholder="Search in table"
        value={searchText}
        onKeyDown={(e) => {
          if (e.key === 'Backspace') {
            onClearInput();
          }
        }}
        onChange={(e) => handleSearch(e.target.value)}
        className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
      />
    </div>
  </div>
  {/* End of search */}

      <section className="mt-5">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={tableData}
          allowCheckBox={true}
          setSelectedRows={selectedTableItems}
          rowKey={(record) => record.Sales_Order_Ref_No}
          handleRowClick={handleRowClick}
        />
      </section>
    </>
  );
};

export default React.memo(SalesOrderPage); // Memoize component